import { Pipe, PipeTransform } from '@angular/core';
import { StorageKeys } from '../../shared/models/storage-keys';

@Pipe({
  name: 'hasRole'
})
export class RoleCheckerPipe implements PipeTransform {
  transform(role: any, ...args: unknown[]): boolean {
    if (role) {
      const currentUserRoles = JSON.parse(localStorage.getItem(StorageKeys.roles)) as string[];
      const splitRoles = role.split(',');
      if (splitRoles.length > 1) {
        return splitRoles.some(str => currentUserRoles.includes(str));
      }
      return currentUserRoles.includes(role);
    }
    return true;
  }
}
